module.exports = __webpack_public_path__ + "img/HQ-PA10W1L.d09a023b.jpg";